import { isServer } from '@sitecore-jss/sitecore-jss/utils';

const ROOT_VALUE = 16;

export const pxToRem = (query: string): string => {
  const regex = new RegExp(/(\d+\.?\d*)px/, 'g');
  return query.replaceAll(regex, (_match, n) => n / ROOT_VALUE + 'rem');
};

export const normalizePx = (value: number): number | undefined => {
  if (isServer()) return;

  const htmlEl = document.querySelector('html');
  const fontSize =
    Number.parseFloat(globalThis.getComputedStyle(htmlEl).getPropertyValue('font-size')) ||
    ROOT_VALUE;
  return (fontSize / ROOT_VALUE) * value;
};
